// Cruscotto.jsx — Cruscotto v3 (F2.3, PRIMA vista migrata a React, flag-gated).
// Replica 1:1 il v1 (server/public/dashboard-module.js): Action Hub "Da fare
// adesso", KPI, calendario mese, agenda aggregata, task manuali con CRUD.
// STESSE chiamate API (api.js), STESSI testi, STESSI stati vuoto/caricamento/
// errore onesti. Chrome sui token del design system (--shell-*), colori
// SEMANTICI dei dati invariati (urgenze, fonti agenda, stati task).
//
// ANTI-DOPPIO-BADGE (dichiarato): questo modulo NON emette MAI 'nav:badge'.
// L'unico emettitore resta bootActionsBadge del v1 (dashboard-module.js:521,
// eager in entrambi i mondi). Sotto v3 il render del v1 è strutturalmente
// spento (mounted=false: onShow/__dashShellNav non più raggiungibili perché
// mount/navigate/openDeepLink dell'entry sono di questo file).
//
// Regole gestionale ereditate dal v1: ogni scrittura conferma o fallisce
// RUMOROSAMENTE (toast su document.body: sopravvive ai re-render); doppio
// submit bloccato con ref SINCRONO (setState è async); errore di rete ⇒ i
// dati restano nel form.

import React from 'react';
import ReactDOM from 'react-dom';
import { label } from '../shell/glossary.js';
import {
  api, fmtDay, todayISO, monthRange,
  MONTHS, SRC_META, ACT_ICON, URG_GROUPS, KPI_DEFS, ACT_PREVIEW, SECTION_IDS,
} from './api.js';

// ---------------------------------------------------------------------------
// Stile: layout #dash-root IDENTICO al v1 (stesse regole, stessa media query);
// classi prefissate d3- (mai collisioni con dsh- del v1); chrome sui token
// --shell-* con fallback ai valori campionati (tokens.css.js).
// ---------------------------------------------------------------------------
const STYLE_ID = 'dsh3-style';

function css() {
  return [
    '#dash-root{position:absolute;inset:0;left:56px;overflow:auto;background:var(--shell-bg,#f8fafc);color:var(--shell-text,#0f172a);font:14px/1.4 system-ui,Segoe UI,Roboto,sans-serif;padding:20px 24px;box-sizing:border-box}',
    '@media(max-width:767px){#dash-root{left:0}}',
    '.d3-h1{font-size:22px;font-weight:700;margin:0 0 2px}',
    '.d3-sub{color:#64748b;font-size:13px;margin:0 0 18px}',
    '.d3-kpis{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:12px;margin-bottom:20px}',
    '.d3-kpi{background:var(--shell-surface,#fff);border:1px solid #e2e8f0;border-radius:12px;padding:14px 16px}',
    '.d3-kpi .v{font-size:26px;font-weight:700;line-height:1}',
    '.d3-kpi .l{color:#64748b;font-size:12px;margin-top:6px}',
    '.d3-grid{display:grid;grid-template-columns:minmax(300px,1fr) minmax(320px,1.1fr);gap:16px;align-items:start}',
    '@media(max-width:900px){.d3-grid{grid-template-columns:1fr}}',
    '.d3-card{background:var(--shell-surface,#fff);border:1px solid #e2e8f0;border-radius:12px;padding:16px}',
    '.d3-card h3{margin:0 0 12px;font-size:15px}',
    '.d3-calhead{display:flex;align-items:center;justify-content:space-between;margin-bottom:10px}',
    '.d3-calhead button{border:1px solid #e2e8f0;background:var(--shell-surface,#fff);border-radius:8px;width:30px;height:30px;cursor:pointer;font-size:16px}',
    '.d3-cal{display:grid;grid-template-columns:repeat(7,1fr);gap:4px}',
    '.d3-dow{text-align:center;color:#94a3b8;font-size:11px;font-weight:600;padding:2px 0}',
    '.d3-day{aspect-ratio:1;border:1px solid #eef2f7;border-radius:8px;padding:4px;cursor:pointer;display:flex;flex-direction:column;gap:2px;background:var(--shell-surface,#fff);min-height:44px}',
    '.d3-day:hover{border-color:var(--shell-primary,#06b6d4)}',
    '.d3-day.d3-other{opacity:.4}',
    '.d3-day.d3-today{border-color:var(--shell-primary,#06b6d4);box-shadow:0 0 0 1px var(--shell-primary,#06b6d4) inset}',
    '.d3-day.d3-sel{background:#ecfeff;border-color:var(--shell-primary,#06b6d4)}',
    '.d3-daynum{font-size:11px;color:#475569;font-weight:600}',
    '.d3-dots{display:flex;flex-wrap:wrap;gap:2px}',
    '.d3-dot{width:6px;height:6px;border-radius:50%}',
    '.d3-ag-item{display:flex;gap:10px;align-items:flex-start;padding:10px;border:1px solid #eef2f7;border-radius:10px;margin-bottom:8px}',
    '.d3-badge{font-size:10px;font-weight:700;color:#fff;border-radius:999px;padding:2px 8px;white-space:nowrap;margin-top:2px}',
    '.d3-ag-title{font-weight:600}',
    '.d3-ag-when{color:#64748b;font-size:12px}',
    '.d3-empty{color:#94a3b8;text-align:center;padding:24px 8px;font-size:13px}',
    '.d3-add{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px}',
    '.d3-add input,.d3-add select{border:1px solid #cbd5e1;border-radius:8px;padding:8px 10px;font:inherit}',
    '.d3-add input[type=text]{flex:1;min-width:160px}',
    '.d3-btn{background:var(--shell-primary-strong,#0e7490);color:#fff;border:0;border-radius:8px;padding:8px 14px;font-weight:600;cursor:pointer}',
    '.d3-btn:disabled{opacity:.6;cursor:default}',
    '.d3-task{display:flex;align-items:center;gap:10px;padding:9px 10px;border:1px solid #eef2f7;border-radius:10px;margin-bottom:7px}',
    '.d3-chk{width:20px;height:20px;border-radius:6px;border:2px solid #cbd5e1;cursor:pointer;flex:0 0 auto;display:flex;align-items:center;justify-content:center;font-size:13px;color:#fff}',
    '.d3-chk.doing{border-color:#f59e0b;color:#f59e0b}',
    '.d3-chk.done{background:#22c55e;border-color:#22c55e}',
    '.d3-task .t{flex:1}.d3-task .t.done{text-decoration:line-through;color:#94a3b8}',
    '.d3-task .due{font-size:12px;color:#64748b}',
    '.d3-del{border:0;background:transparent;color:#cbd5e1;cursor:pointer;font-size:16px}.d3-del:hover{color:#ef4444}',
    '.d3-link{border:0;background:transparent;cursor:pointer;font-size:12px;color:var(--shell-primary-strong,#0e7490);font:inherit}',
    '.d3-err{background:#fef2f2;border:1px solid #fecaca;color:#b91c1c;border-radius:10px;padding:10px 12px;margin-bottom:12px}',
    '.d3-toast{position:fixed;bottom:20px;left:50%;transform:translateX(-50%) translateY(20px);background:#0f172a;color:#fff;padding:10px 18px;border-radius:10px;opacity:0;transition:.3s;z-index:99999;font-size:13px}',
    '.d3-toast.d3-show{opacity:1;transform:translateX(-50%) translateY(0)}',
    '.d3-toast-err{background:var(--shell-danger,#e11d48)}',
    '.d3-actions{margin-bottom:20px}',
    '.d3-act-group{border:1px solid;border-radius:10px;padding:8px 10px;margin-bottom:10px}',
    '.d3-act-group h4{margin:0 0 6px;font-size:12px;font-weight:700;letter-spacing:.03em;text-transform:uppercase}',
    '.d3-act-row{display:flex;align-items:center;gap:10px;padding:7px 8px;border-radius:8px;cursor:pointer;background:transparent}',
    '.d3-act-row:hover{background:rgba(255,255,255,.75);box-shadow:0 0 0 1px #e2e8f0 inset}',
    '.d3-act-ico{flex:0 0 22px;text-align:center;font-size:15px;line-height:1}',
    '.d3-act-title{flex:1;font-weight:600;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
    '.d3-act-when{color:#64748b;font-size:12px;white-space:nowrap}',
    '.d3-act-go{flex:0 0 auto;color:var(--shell-primary-strong,#0e7490);font-weight:700;font-size:15px}',
    '.d3-act-more{border:0;background:transparent;color:var(--shell-primary-strong,#0e7490);font:inherit;font-size:12px;cursor:pointer;padding:4px 8px}',
    '.d3-act-ok{display:flex;align-items:center;gap:8px;color:#15803d;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:10px;padding:10px 12px;font-size:13px}',
  ].join('\n');
}

function injectStyle(doc) {
  if (doc.getElementById(STYLE_ID)) return;
  const st = doc.createElement('style');
  st.id = STYLE_ID;
  st.textContent = css();
  doc.head.appendChild(st);
}

// Toast su document.body (come il v1): sopravvive ai re-render e resta l'unica
// risposta visibile dell'azione (regola UI 3.3). Imperativo consapevole.
function toast(doc, msg, kind) {
  const t = doc.createElement('div');
  t.className = 'd3-toast d3-toast-' + (kind || 'ok');
  t.textContent = msg;
  doc.body.appendChild(t);
  setTimeout(() => { t.classList.add('d3-show'); }, 10);
  setTimeout(() => { t.classList.remove('d3-show'); setTimeout(() => { t.remove(); }, 300); }, 3200);
}

// ---------------------------------------------------------------------------
// Componente
// ---------------------------------------------------------------------------
export function Cruscotto({ win, registerHandle, scrollToSection }) {
  const doc = win.document;
  const now = new Date();
  const [cal, setCal] = React.useState({ year: now.getFullYear(), month: now.getMonth() });
  const [selectedDay, setSelectedDay] = React.useState(null);
  const [kpi, setKpi] = React.useState(null);
  const [agenda, setAgenda] = React.useState([]);
  const [tasks, setTasks] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const [actions, setActions] = React.useState(null);
  const [actionsLoading, setActionsLoading] = React.useState(false);
  const [actionsError, setActionsError] = React.useState(null);
  const [expanded, setExpanded] = React.useState({});
  // form task controllato: i valori si puliscono SOLO dopo conferma del server
  const [fTitle, setFTitle] = React.useState('');
  const [fDue, setFDue] = React.useState('');
  const [fPrio, setFPrio] = React.useState('normal');
  const titleRef = React.useRef(null);

  // ref SINCRONI: guardie anti-doppio-submit / anti-fetch-concorrente (parità
  // state.saving/_actionsInflight del v1 — setState React è asincrono).
  const savingRef = React.useRef(false);
  const actionsInflight = React.useRef(false);
  const loadingRef = React.useRef(false);
  const alive = React.useRef(true);
  React.useEffect(() => () => { alive.current = false; }, []);

  const loadActions = React.useCallback(async () => {
    if (actionsInflight.current) return;
    actionsInflight.current = true;
    setActionsLoading(true); setActionsError(null);
    try {
      const res = await api(win, '/actions');
      if (alive.current) setActions(res || { count: 0, byUrgency: {}, items: [] });
      // NIENTE emissione del badge (nav:badge): resta al poller del v1.
    } catch (e) {
      if (alive.current) setActionsError(e.message || 'Errore di caricamento azioni');
    } finally {
      actionsInflight.current = false;
      if (alive.current) setActionsLoading(false);
    }
  }, [win]);

  const loadAll = React.useCallback(async (year, month) => {
    setLoading(true); loadingRef.current = true; setError(null);
    loadActions(); // in parallelo, con stato d'errore SUO (parità v1)
    try {
      const { from, to } = monthRange(year, month);
      const res = await Promise.all([
        api(win, '/kpi'),
        api(win, '/agenda?from=' + from + '&to=' + to),
        api(win, '/tasks'),
      ]);
      if (!alive.current) return;
      setKpi(res[0]);
      setAgenda((res[1] && res[1].items) || []);
      setTasks(res[2] || []);
    } catch (e) {
      if (alive.current) setError(e.message || 'Errore di caricamento');
    } finally {
      loadingRef.current = false;
      if (alive.current) setLoading(false);
    }
  }, [win, loadActions]);

  // all'apertura e a ogni cambio mese: SEMPRE dal server (parità onShow v1)
  React.useEffect(() => { loadAll(cal.year, cal.month); }, [cal.year, cal.month, loadAll]);

  // handle per navigate/openDeepLink della factory (scroll a sezione quando
  // i dati sono assestati — parità __dashShellNav v1) + reload per il mount
  // idempotente (re-attivazione del modulo GIÀ montato: dati freschi come
  // onShow v1, stato React — bozza del form task inclusa — conservato).
  // reload sempre FRESCO sul mese visibile: ref aggiornata a ogni render
  // (l'handle vive fuori dal render — una closure diretta resterebbe stantia).
  const reloadRef = React.useRef(null);
  reloadRef.current = () => loadAll(cal.year, cal.month);
  React.useEffect(() => {
    registerHandle({ isLoading: () => loadingRef.current, reload: () => reloadRef.current() });
    return () => registerHandle(null);
  }, [registerHandle]);

  // ---- azioni (parità semantica v1) ----
  async function addTask(ev) {
    ev.preventDefault();
    if (savingRef.current) return; // anti doppio-submit (sincrono)
    const title = fTitle.trim();
    if (!title) { toast(doc, 'Inserisci un titolo', 'err'); if (titleRef.current) titleRef.current.focus(); return; }
    savingRef.current = true; setSaving(true);
    try {
      await api(win, '/tasks', { method: 'POST', body: {
        title, due_at: fDue || null, priority: fPrio || 'normal',
      } });
      if (alive.current) { setFTitle(''); setFDue(''); } // pulisci SOLO dopo conferma server
      toast(doc, 'Task salvata');
      await loadAll(cal.year, cal.month);
    } catch (e) {
      toast(doc, 'NON salvata: ' + e.message, 'err'); // i dati restano nel form
    } finally {
      savingRef.current = false;
      if (alive.current) setSaving(false);
    }
  }

  async function cycleStatus(task) {
    const next = task.status === 'todo' ? 'doing' : task.status === 'doing' ? 'done' : 'todo';
    try {
      await api(win, '/tasks/' + encodeURIComponent(task.id), { method: 'PATCH', body: { status: next } });
      await loadAll(cal.year, cal.month);
    } catch (e) { toast(doc, 'Aggiornamento fallito: ' + e.message, 'err'); }
  }

  async function delTask(task) {
    if (!win.confirm('Eliminare la task «' + task.title + '»?')) return;
    try {
      await api(win, '/tasks/' + encodeURIComponent(task.id), { method: 'DELETE' });
      toast(doc, 'Task eliminata');
      await loadAll(cal.year, cal.month);
    } catch (e) { toast(doc, 'Eliminazione fallita: ' + e.message, 'err'); }
  }

  // Deep-link di un action item — STESSA semantica di openActionLink v1
  // (dashboard-module.js:225-244): dash ⇒ scroll interno; altri moduli ⇒
  // Workspaces v2 navigate. Il fallback workspace-host legacy del v1 qui è
  // irraggiungibile (il v3 esiste SOLO sotto shell v2): toast dichiarato.
  function openActionLink(item) {
    const link = (item && item.link) || {};
    const mod = link.module || 'proc';
    const view = link.view || null;
    // F3.3 (ondata 16): params = INTERO link (kind, supplierId, campaignId, productId, …)
    // — prima passava solo id e l'adapter del modulo target non poteva atterrare sul RECORD.
    const params = Object.assign({}, link, { from: 'dash-actions' });
    if (mod === 'dash') { scrollToSection(view || 'tasks'); return; }
    const W = win.Workspaces;
    if (W && W.version === 2 && typeof W.navigate === 'function') {
      W.navigate(mod, view || undefined, view ? params : undefined);
      return;
    }
    toast(doc, 'Navigazione non disponibile: apri il modulo ' + mod + ' manualmente', 'err');
  }

  function shiftMonth(delta) {
    const m = cal.month + delta;
    setSelectedDay(null);
    setCal({ year: cal.year + Math.floor(m / 12), month: ((m % 12) + 12) % 12 });
  }

  // ---- render: card "Da fare adesso" (F3.1) ----
  function renderActionsCard() {
    let body;
    if (actionsError) {
      body = (
        <React.Fragment>
          <div className="d3-err" style={{ marginBottom: 0 }}>{'⚠ Azioni non caricate: ' + actionsError + ' — riprova.'}</div>
          <button type="button" className="d3-act-more" onClick={() => loadActions()}>Riprova adesso</button>
        </React.Fragment>
      );
    } else if (!actions) {
      body = <div className="d3-empty">{actionsLoading ? 'Caricamento…' : '—'}</div>;
    } else {
      const items = actions.items || [];
      let shown = 0;
      const groups = URG_GROUPS.map((g) => {
        const group = items.filter((i) => i.urgency === g.key);
        if (!group.length) return null;
        shown += group.length;
        const max = expanded[g.key] ? group.length : ACT_PREVIEW;
        return (
          <div key={g.key} className="d3-act-group" style={{ background: g.bg, borderColor: g.border }}>
            <h4 style={{ color: g.color }}>{g.label + ' (' + group.length + ')'}</h4>
            {group.slice(0, max).map((i, idx) => (
              <div key={(i.source || '') + '-' + (i.id || idx)} className="d3-act-row" title={i.title} onClick={() => openActionLink(i)}>
                <span className="d3-act-ico">{ACT_ICON[i.action_type] || '•'}</span>
                <span className="d3-act-title">{i.title}</span>
                <span className="d3-act-when">{fmtDay(i.when)}</span>
                <span className="d3-act-go">→</span>
              </div>
            ))}
            {group.length > max && (
              <button type="button" className="d3-act-more" onClick={() => setExpanded((e) => Object.assign({}, e, { [g.key]: true }))}>
                {'Mostra altre ' + (group.length - max) + '…'}
              </button>
            )}
          </div>
        );
      });
      body = (
        <React.Fragment>
          {groups}
          {!shown && (
            <div className="d3-act-ok"><span>✓</span><span>Niente da fare: tutto sotto controllo.</span></div>
          )}
        </React.Fragment>
      );
    }
    return (
      <div className="d3-card d3-actions" data-d3-sec="actions">
        <h3>Da fare adesso</h3>
        {body}
      </div>
    );
  }

  // ---- render: calendario ----
  function renderCalendar() {
    const byDay = {};
    agenda.forEach((i) => { (byDay[i.when] = byDay[i.when] || []).push(i); });

    const first = new Date(cal.year, cal.month, 1);
    const startDow = (first.getDay() + 6) % 7; // lunedì = 0
    const daysInMonth = new Date(cal.year, cal.month + 1, 0).getDate();
    const prevDays = new Date(cal.year, cal.month, 0).getDate();
    const cells = [];
    for (let i = 0; i < startDow; i++) cells.push({ n: prevDays - startDow + 1 + i, other: true });
    for (let d = 1; d <= daysInMonth; d++) cells.push({ n: d, other: false });
    while (cells.length % 7 !== 0) cells.push({ n: cells.length - (startDow + daysInMonth) + 1, other: true });

    const today = todayISO();
    return (
      <div className="d3-card" data-d3-sec="calendar">
        <div className="d3-calhead">
          <button type="button" title="Mese precedente" onClick={() => shiftMonth(-1)}>‹</button>
          <h3 style={{ margin: 0 }}>{MONTHS[cal.month] + ' ' + cal.year}</h3>
          <button type="button" title="Mese successivo" onClick={() => shiftMonth(1)}>›</button>
        </div>
        <div className="d3-cal">
          {['L', 'M', 'M', 'G', 'V', 'S', 'D'].map((d, i) => <div key={'dow' + i} className="d3-dow">{d}</div>)}
          {cells.map((c, idx) => {
            const iso = c.other ? null : cal.year + '-' + String(cal.month + 1).padStart(2, '0') + '-' + String(c.n).padStart(2, '0');
            const cls = 'd3-day' + (c.other ? ' d3-other' : '') + (iso === today ? ' d3-today' : '') + (iso && iso === selectedDay ? ' d3-sel' : '');
            const items = iso ? (byDay[iso] || []) : [];
            const seen = {};
            const dots = [];
            items.forEach((it) => {
              if (seen[it.source]) return;
              seen[it.source] = 1;
              dots.push(<div key={it.source} className="d3-dot" style={{ background: (SRC_META[it.source] || {}).color }} />);
            });
            return (
              <div
                key={'c' + idx} className={cls}
                title={items.length ? items.length + ' voce/i' : undefined}
                onClick={() => { if (!iso) return; setSelectedDay(selectedDay === iso ? null : iso); }}
              >
                <div className="d3-daynum">{String(c.n)}</div>
                <div className="d3-dots">{dots}</div>
              </div>
            );
          })}
        </div>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 10, fontSize: 11, color: '#64748b' }}>
          {Object.keys(SRC_META).map((s) => (
            <span key={s} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
              <span className="d3-dot" style={{ background: SRC_META[s].color }} />{SRC_META[s].label}
            </span>
          ))}
        </div>
      </div>
    );
  }

  // ---- render: colonna destra (agenda + task) ----
  function renderAgendaCard() {
    const list = agenda.filter((i) => !selectedDay || i.when === selectedDay);
    return (
      <div className="d3-card" style={{ marginBottom: 16 }} data-d3-sec="agenda">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0 }}>{selectedDay ? ('Agenda — ' + fmtDay(selectedDay)) : 'Agenda del mese'}</h3>
          {selectedDay && <button type="button" className="d3-link" onClick={() => setSelectedDay(null)}>mostra tutto</button>}
        </div>
        {loading && !agenda.length ? (
          <div className="d3-empty">Caricamento…</div>
        ) : !list.length ? (
          <div className="d3-empty">Nessun elemento in agenda.</div>
        ) : (
          list.map((i, idx) => {
            const m = SRC_META[i.source] || { label: i.source, color: '#94a3b8' };
            return (
              <div key={(i.source || '') + '-' + (i.id || idx) + '-' + (i.when || '')} className="d3-ag-item">
                <span className="d3-badge" style={{ background: m.color }}>{m.label}</span>
                <div style={{ flex: 1 }}>
                  <div className="d3-ag-title">{i.title}</div>
                  <div className="d3-ag-when">{fmtDay(i.when)}</div>
                </div>
              </div>
            );
          })
        )}
      </div>
    );
  }

  function renderTasksCard() {
    return (
      <div className="d3-card" data-d3-sec="tasks">
        <h3>Le mie task</h3>
        <form className="d3-add" onSubmit={addTask}>
          <input ref={titleRef} type="text" placeholder="Nuova task…" name="title" value={fTitle} onChange={(e) => setFTitle(e.target.value)} />
          <input type="date" name="due" title="Scadenza" value={fDue} onChange={(e) => setFDue(e.target.value)} />
          <select name="prio" value={fPrio} onChange={(e) => setFPrio(e.target.value)}>
            <option value="normal">Normale</option>
            <option value="high">Alta</option>
            <option value="low">Bassa</option>
          </select>
          <button className="d3-btn" type="submit" disabled={saving}>{saving ? 'Salvo…' : 'Aggiungi'}</button>
        </form>
        {loading && !tasks.length ? (
          <div className="d3-empty">Caricamento…</div>
        ) : !tasks.length ? (
          <div className="d3-empty">Nessuna task. Aggiungine una qui sopra.</div>
        ) : (
          tasks.map((t) => (
            <div key={t.id} className="d3-task">
              <div
                className={'d3-chk ' + (t.status === 'done' ? 'done' : t.status === 'doing' ? 'doing' : '')}
                title={'Stato: ' + t.status + ' (click per cambiare)'}
                onClick={() => cycleStatus(t)}
              >{t.status === 'done' ? '✓' : t.status === 'doing' ? '•' : ''}</div>
              <div className={'t' + (t.status === 'done' ? ' done' : '')} style={{ flex: 1 }}>
                <div>{t.title}</div>
                {t.due_at ? <div className="due">{'scad. ' + fmtDay(t.due_at)}</div> : null}
              </div>
              <button type="button" className="d3-del" title="Elimina" onClick={() => delTask(t)}>✕</button>
            </div>
          ))
        )}
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="d3-h1">Cruscotto</div>
      <div className="d3-sub">Tutto ciò che richiede attenzione, in un colpo d'occhio.</div>
      {error && <div className="d3-err">{'⚠ ' + error + ' — controlla la connessione e riprova.'}</div>}
      {renderActionsCard()}
      <div className="d3-kpis" data-d3-sec="kpi">
        {KPI_DEFS.map(([field, lbl]) => (
          <div key={field} className="d3-kpi">
            <div className="v">{loading && kpi == null ? '…' : String(kpi == null || kpi[field] == null ? 0 : kpi[field])}</div>
            <div className="l">{lbl}</div>
          </div>
        ))}
      </div>
      <div className="d3-grid">
        {renderCalendar()}
        <div>
          {renderAgendaCard()}
          {renderTasksCard()}
        </div>
      </div>
    </React.Fragment>
  );
}

// ---------------------------------------------------------------------------
// Factory per l'entry del registry: mount/unmount + navigate/openDeepLink.
// Il host (host.js:199) chiama mount(#dash-root, {bus}); l'elemento può NON
// esistere ancora (col v3 al comando l'ensureRoot del v1 non gira mai): si
// crea qui, stesso id, stessa posizione (body) — le regole CSS bulletproof
// e la geometria shell bersagliano #dash-root per id.
// ---------------------------------------------------------------------------
export function createDashV3(win) {
  let reactRoot = null;
  let mountedEl = null;   // elemento su cui vive il root React (idempotenza mount)
  let handle = null; // { isLoading, reload } registrato dal componente montato

  function ensureRootEl() {
    let r = win.document.getElementById('dash-root');
    if (!r) {
      r = win.document.createElement('div');
      r.id = 'dash-root';
      win.document.body.appendChild(r);
    }
    return r;
  }

  // Scroll a una sezione reale della pagina (parità __dashShellNav v1):
  // parte SOLO a dati assestati — il primo render ha liste vuote e il target
  // può non esserci o spostarsi. Best-effort ≤40×150ms, mai throw.
  function scrollToSection(sectionId) {
    if (SECTION_IDS.indexOf(sectionId) === -1) return false;
    let tries = 0;
    (function go() {
      const target = win.document.querySelector('#dash-root [data-d3-sec="' + sectionId + '"]');
      const busy = !handle || handle.isLoading();
      if ((busy || !target) && ++tries < 40) return win.setTimeout(go, 150);
      if (target) target.scrollIntoView({ block: 'start' });
    })();
    return true;
  }

  function mount(el) {
    injectStyle(win.document);
    const rootEl = el || ensureRootEl();
    // IDEMPOTENZA (mai perdita dati — fratello del bug perdita-bozza sop-v3):
    // il host chiama mount() a OGNI attivazione, anche su modulo GIÀ attivo
    // (Workspaces.navigate → activate → activateGuest → w.mount, host.js:199).
    // Un remount qui azzererebbe lo stato React — la bozza nel form "Nuova
    // task…" sparirebbe in silenzio. Se il root React è già vivo sullo STESSO
    // elemento ancora in pagina, si conserva l'albero (bozza intatta) e si
    // ricaricano SOLO i dati dal server (parità onShow v1). Il RICARICO su
    // lascia-e-riapri resta garantito da unmount() (deactivate lo chiama
    // sempre uscendo, host.js:174). Stesso pattern di sop-v3/Sop.jsx.
    if (reactRoot && mountedEl === rootEl && rootEl && rootEl.isConnected) {
      if (handle && typeof handle.reload === 'function') handle.reload();
      return;
    }
    if (reactRoot) { try { reactRoot.unmount(); } catch (e) { /* già smontato */ } }
    mountedEl = rootEl;
    reactRoot = ReactDOM.createRoot(rootEl);
    reactRoot.render(
      <Cruscotto
        win={win}
        registerHandle={(h) => { handle = h; }}
        scrollToSection={scrollToSection}
      />
    );
  }

  function unmount() {
    if (reactRoot) {
      try { reactRoot.unmount(); } catch (e) { /* già smontato */ }
      reactRoot = null;
    }
    mountedEl = null;
    handle = null;
  }

  // Voce del sottomenù shell (nav[] dell'adapter dash-v2, preservata
  // dall'update): scroll v3 — voce ignota ⇒ toast dal catalogo (mai silenzio).
  function navigate(itemId) {
    if (scrollToSection(itemId) !== true) {
      const W = win.Workspaces;
      if (W && W.bus && typeof W.bus.emit === 'function') {
        W.bus.emit('toast', { kind: 'error', msg: label('shell.bridge.missing') + itemId });
      }
    }
  }

  function openDeepLink(l) {
    return !!(l && typeof l.item === 'string' && scrollToSection(l.item) === true);
  }

  return { mount, unmount, navigate, openDeepLink };
}
